import axios, {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from 'axios';

interface BaseUrlProvider {
  (): string
}
export default function makeApi(getBaseUrl: BaseUrlProvider): AxiosInstance {
  const api = axios.create();

  // Base URL needs to be set at runtime to allow a single Docker image
  // to run in different environments
  function setBaseURL(request: AxiosRequestConfig): AxiosRequestConfig {
    request.baseURL = getBaseUrl();
    return request;
  }

  /* eslint-disable */
// Setting this option when creating the axios (although it's meant to)
// instance does not work so an interceptor must be used.
  function sendCookies(config: AxiosRequestConfig) {
    config.withCredentials = true;
    return config;
  }
  /* eslint-enable */

  function fetchCreatedResource(response: AxiosResponse) {
    if (response.status !== 201) {
      return response;
    }
    if (Object.keys(response.data).length > 0) {
      return response;
    }
    const { location } = response.headers;
    if (location) return api.get(location);
    return response;
  }

  function createQueryResult(response: AxiosResponse): AxiosResponse {
    if (response.status !== 200 || !('x-total-items' in response.headers)) {
      return response;
    }
    return Object.assign(response, {
      data: {
        total: parseInt(response.headers['x-total-items'], 10),
        items: response.data,
      },
    });
  }

  function setErrorMessage(error: AxiosError) {
    if (!error.response) {
      return Promise.reject(error);
    }
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({
      ...error,
      message: error.response.data.message,
    });
  }

  api.interceptors.request.use(setBaseURL);
  api.interceptors.request.use(sendCookies);
  api.interceptors.response.use(fetchCreatedResource);
  api.interceptors.response.use(createQueryResult);
  api.interceptors.response.use(undefined, setErrorMessage);

  return api;
}
